export default "__VITE_ASSET__CL9vM_u4__"